import { entryFilesService } from '@patient/services/entry/entryFilesService';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import isEmpty from 'lodash/isEmpty';

import '@components/mixins/commonStyles.scss';
import style from './ExaminationLink.module.scss';

import { translate } from '@chaika/i18n/helper';

import { entryPageService } from '@patient/ui/shared/store';

import { Input } from '@components/Input';
import { Button } from '@components/Button';

import { ExaminationLinkDataTest } from '@patient/ui/shared/ExaminationLink/data-test';

const PACS_REGEX = /^https?:\/\/pacs\.chaika\.com\/osimis\-viewer\/app\/index\.html\?study=(?:[0-9a-fA-F]{8}-?){5}$/g;
const NEW_PACS_REGEX = /^https:\/\/pacs\.chaika\.com\/ohif\/viewer\?.*StudyInstanceUIDs=([0-9\.]+)/g;

export const ExaminationLink = observer((): React.ReactElement<any> => {
    const tExaminationLink = translate('examinationLink');
    const tAdd = translate('add');

    const [examinationLink, setExaminationLink] = useState('');

    const isValid =
        !isEmpty(examinationLink) &&
        (!isEmpty(examinationLink.match(PACS_REGEX)) || !isEmpty(examinationLink.match(NEW_PACS_REGEX)));

    const onSave = async () => {
        await entryFilesService.addPacsLink(examinationLink);
        entryPageService.resetRightContent();
    };

    return (
        <div className={style.root}>
            <div className={'font_h2'}>{tExaminationLink}</div>
            <Input
                isValid={isValid}
                dataTest={ExaminationLinkDataTest.LinkInput}
                title={tExaminationLink}
                placeholder={tExaminationLink}
                value={examinationLink}
                onChange={e => setExaminationLink(e.target.value)}
            />
            <div>
                <Button
                    dataTest={ExaminationLinkDataTest.SaveButton}
                    disabled={!isValid}
                    label={tAdd}
                    onClick={onSave}
                />
            </div>
        </div>
    );
});
